const TOP_RATED = "/top_rated";
const UP_COMING = "/upcoming";
const NOW_PLAYING = "/now_playing";
const POPULAR = "/popular";
const FAVORITES = "/favorites";
const DETAILS = "/details";

export const path = {
  TOP_RATED,
  UP_COMING,
  NOW_PLAYING,
  POPULAR,
  FAVORITES,
  DETAILS,
};
